import { ref, computed } from '@vue/composition-api';
import conflictDetectorWorker from '@/location/conflict-detector.worker';
import moment from 'moment-timezone';
import deepmerge from 'deepmerge';

const conflictDetector = conflictDetectorWorker();

export default function useBookingConflict (bookings, booking, currentTime, startTime) {
  const bookingConflict = ref(false);
  const longestTierLength = ref(0);

  const mockBooking = computed(() => {
    const mockBooking = deepmerge({}, booking.value);

    longestTierLength.value = 0;

    if (!mockBooking.checkedInAt && mockBooking._startNow) {
      mockBooking.checkedInAt = currentTime.value;
    }

    mockBooking.bookingStationTimes.forEach(bookingStationTime => {
      const tier = bookingStationTime.tier;
      if (tier.length > longestTierLength.value) longestTierLength.value = tier.length;

      if (!bookingStationTime.startedAt) {
        bookingStationTime.endTime = moment(startTime.value).add(tier.length, 'minutes').format();
      }
    });

    mockBooking.startTime = startTime.value;

    return mockBooking;
  });

  async function setConflictBooking () {
    const conflict = await conflictDetector.willBookingCauseConflict(
      mockBooking.value,
      bookings.value,
    );
    bookingConflict.value = !!conflict;
  }

  return {
    bookingConflict,
    setConflictBooking,
    longestTierLength,
  };
}
